import { z } from 'zod';

export const budgetFormSchema = z.object({
  categoryId: z.string().min(1, 'Category is required'),
  amount: z
    .string()
    .min(1, 'Amount is required')
    .refine((v) => parseFloat(v) > 0, 'Must be greater than 0'),
  periodType: z.enum(['weekly', 'monthly', 'yearly']),
  assignedTo: z.string(),
  startDate: z.string(),
  rollover: z.boolean(),
  notifyAtPercent: z.number().min(50).max(100),
});

export type BudgetFormValues = z.infer<typeof budgetFormSchema>;

export const budgetFormDefaults: BudgetFormValues = {
  categoryId: '',
  amount: '',
  periodType: 'monthly',
  assignedTo: 'household',
  startDate: '',
  rollover: false,
  notifyAtPercent: 80,
};
